<template>
	<div ref="myElement" class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="list_box">
						<div class="left">
							<div v-for="(value, index) in newsList" :key="index" class="list_el"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								@click="goInfo(value)"
							>
								<div class="time">{{ value.fabu_time }}</div>
								<div class="tit">{{ value.title }}</div>
							</div>
						</div>
						<div class="right"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../../assets/img_public/support/bg.webp" />
						</div>
					</div>
					<div v-if="newsList.length > 0" class="page_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<el-pagination
							:small="false"
							background
							layout="prev, pager, next"
							:total="total"
							:page-size="10"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
	</div>
</template>

<script>
import { supportList } from '@/api/public';  //新闻列表
import { UPURL } from '@/util/util';
import moment from 'moment';
moment.locale('zh-cn');
export default {
	components:{
		//
	},
	data() {
		return {
			newsList: [],
			page: 1,
			total: 0,
			listLoading: true,
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		//获取新闻列表
		that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
		that.getList();
	},
	watch: {
		//
	},
	methods: {
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		},
		//获取列表
		getList(type) {
			let that = this;
			that.listLoading = true;
			supportList({
				page: that.page,
				page_size: 10,
				leixing: 1,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.newsList = res.data.data;
				that.total = res.data.total;
				that.listLoading = false;
				that.$toast.clear();
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "SupportInfo", params: { supportInfoId: value.id + '.html' } });
			window.open(routeData.href, '_blank');
		},
		initTime1(value) {
			return moment(value).format('DD');
		},
		initTime2(value) {
			return moment(value).format('YYYY-MM');
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 60px 0 80px 0;
		background-color: #F7F6F9;
		.block_1_main{
			width: 1264px;
			margin: 0 auto;
			.page_box{
				padding-top: 80px;
				text-align: center;
			}
			.list_box{
				display: flex;
				align-items: flex-start;
				.left{
					flex: 1;
					padding-right: 64px;
					.list_el{
						display: flex;
						align-items: center;
						padding: 36px 40px;
						background-color: #ffffff;
						border-radius: 8px;
						margin-bottom: 30px;
						cursor: pointer;
						.tit{
							padding-left: 20px;
							font-size: 20px;
							color: #000000;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							-webkit-box-orient: vertical;
						}
						.time{
							width: auto;
							font-size: 20px;
							color: #999999;
							white-space: nowrap;
						}
					}
					.list_el:hover{
						.tit{
							color: #A50073;
						}
					}
					.list_el:last-child{
						margin-bottom: 0;
					}
				}
				.right{
					width: 400px;
					img{
						width: 100%;
					}
				}
			}
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>